import { faChevronUp, faCircleNotch, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function TransactionsTable({ transactions, page, sort, setSort, handleTransactionDetailsView }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="rounded-2xl bg-backdrop mt-5 overflow-x-auto">
        <table className="w-full text-xs text-left font-medium">
          <thead className="bg-card text-white ">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <th scope="col" className="py-3 px-6">
                {t("TRANSACTION_ID")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("TRANSACTION_TYPE")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("TRANSACTION_AMOUNT")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("O_STATUS")}
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer "
                onClick={() => {
                  if (sort.sort_key === "createdAt" && sort.sort_type === "asc") {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start gap-2">
                  <span>{t("O_CREATED_AT")}</span>
                  <span>
                    {sort.sort_key === "createdAt" && sort.sort_type === "asc" && <FontAwesomeIcon icon={faChevronUp} className="w-4 h-4 card-icon" />}
                    {sort.sort_key === "createdAt" && sort.sort_type === "desc" && <FontAwesomeIcon icon={faChevronUp} className="w-4 h-4 rotate-180 card-icon" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("O_DETAILS")}
              </th>
            </tr>
          </thead>
          <tbody>
            {transactions &&
              transactions?.map((item, i) => (
                <tr key={i} className="border-t bg-[var(--backdrop)] border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white border-gray-700">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r border-gray-700">{item?.transaction_id}</td>
                  <td className="py-4 px-6 border-r border-gray-700">{item?.transaction_type}</td>
                  <td className={`py-4 px-6 border-r text-right border-gray-700 ${item.type === "debit" ? "text-red-500" : "text-green-500"}`}>
                    {item.type === "debit" ? "-" : "+"}{item?.transaction_amount?.toFixed(2)}{item.transaction_currency}
                  </td>
                  <td className="py-4 px-6 border-r border-gray-700">{t(item?.status)}</td>
                  <td className="py-4 px-6 border-r border-gray-700">{dayjs(item?.createdAt).format("DD-MM-YYYY hh:mm A")}</td>
                  <td className="py-4 px-6">
                    <div className="">
                      <ul className="flex justify-center">
                        <li onClick={() => handleTransactionDetailsView(item)} className="px-2 py-2">
                          <span title={t("O_DETAILS")}>
                            {" "}
                            <FontAwesomeIcon icon={faEye} className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {!transactions && (
              <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={9}>
                  <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin" />
                </td>
              </tr>
            )}
            {transactions && transactions.length === 0 ? (
              <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={9}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </>
  );
}
